var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import Url from "url-parse";
import queryString from "query-string";
import { ArrowLightIcon } from "@riseart/icons";
import { Link } from "../link/Link";
import { infiniteScrollPaginationCls, infiniteScrollSensorCls, infiniteScrollButtonCls } from "./InfiniteScroll.less";
var DEFAULT_OFFSET = {
  top: 0,
  right: 0,
  bottom: -500,
  // start change in scroll visibility -500px before sensor is visible in viewport
  left: 0
};
var InfiniteScrollPagination = /* @__PURE__ */ __name(function InfiniteScrollPagination2(_ref) {
  var style = _ref.style, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? DEFAULT_OFFSET : _ref$offset, onChange = _ref.onChange, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$autoLoading = _ref.autoLoading, autoLoading = _ref$autoLoading === void 0 ? true : _ref$autoLoading, _ref$showButton = _ref.showButton, showButton = _ref$showButton === void 0 ? true : _ref$showButton, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, current = _ref.current, totalPages = _ref.totalPages, baseUrl = _ref.baseUrl, _ref$translations = _ref.translations, translations = _ref$translations === void 0 ? {
    next: ""
  } : _ref$translations, Loader = _ref.loader;
  var linkComponent = null;
  if (current !== totalPages && !isLoading && (showButton || !autoLoading)) {
    var parsedUrl = new Url(baseUrl);
    var parsedQueryString = queryString.parse(parsedUrl.query);
    linkComponent = /* @__PURE__ */ React.createElement(Link, {
      to: "".concat(parsedUrl.pathname, "?").concat(queryString.stringify(_objectSpread(_objectSpread({}, parsedQueryString), {}, {
        page: current + 1
      }))),
      title: translations && translations.next || "",
      onClick: onChange,
      className: infiniteScrollButtonCls
    }, /* @__PURE__ */ React.createElement(ArrowLightIcon, null));
  }
  return /* @__PURE__ */ React.createElement("div", {
    className: infiniteScrollPaginationCls,
    style
  }, autoLoading ? /* @__PURE__ */ React.createElement(VisibilitySensor, {
    onChange,
    offset,
    scrollCheck: true,
    scrollDelay: 0,
    active: !isLoading
  }, /* @__PURE__ */ React.createElement("div", {
    className: infiniteScrollSensorCls
  })) : null, Loader && /* @__PURE__ */ React.createElement(Loader, {
    isActive: isLoading
  }), children, linkComponent);
}, "InfiniteScrollPagination");
export {
  InfiniteScrollPagination
};
